import React from "react";
const CMSNavbar = ({ setActivePage, activePage }) => {
  const pages = [
    "Crew Working Hours",
    "Crew Utilization",
    "Crew PDD",
    "HQ Crew Rest At Outstation",
    "Outstation Crew Rest At HQ",
    "Average Rest",
  ];
  const handleBtnClick = (btnName) => {
    setActivePage(btnName);
  };
  return (
    <div className="newUiBody">
      {pages.map((button, index) => {
        return (
          <button
            key={index}
            className={`btn btn-outline-dark m-1 ${
              activePage === button && "active"
            }`}
            onClick={() => {
              handleBtnClick(button);
            }}
          >
            {button}
          </button>
        );
      })}
    </div>
  );
};
export default CMSNavbar;
